/*
 * Scroll-reveal for brand-content blocks (GSAP + ScrollTrigger).
 * Replaces the old Webflow IX2 fade-up. Elements marked [data-reveal]
 * start hidden (via the .brand-reveal-on CSS guard) and fade up when
 * scrolled into view. If GSAP fails to load, the guard is removed so
 * content is always shown.
 */
(function () {
  var root = document.documentElement;

  function run() {
    if (!window.gsap || !window.ScrollTrigger) {
      root.classList.remove('brand-reveal-on');
      return;
    }
    gsap.registerPlugin(ScrollTrigger);

    var els = document.querySelectorAll('[data-reveal]');
    els.forEach(function (el) {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          once: true
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }

  // Safety net: if GSAP never becomes available, reveal everything.
  setTimeout(function () {
    if (!window.gsap) {
      root.classList.remove('brand-reveal-on');
    }
  }, 2500);
})();
